// Basemap styles and MapTiler access.
//
// The basemap styles live in public/map-styles/ (owned by this app). Their
// tile, font and satellite URLs point at api.maptiler.com without a key; the
// key is appended here at request time from VUE_APP_MAPTILER_KEY so it is
// never committed. The key is public in the browser: restrict it to the
// TrailHUB origins in the MapTiler dashboard.
export const MAPTILER_KEY = process.env.VUE_APP_MAPTILER_KEY || ''

const origin = () => window.location.origin

export const MAP_STYLES = {
  trailhub: () => origin() + '/map-styles/trailhub.json',
  dark: () => origin() + '/map-styles/dark.json',
  // Satellite + labels style from the MapTiler account (used by Menu.vue).
  satellite: () => 'https://api.maptiler.com/maps/da520b6d-739a-4646-888f-1d3f2b664f78/style.json'
}

if (!MAPTILER_KEY && process.env.NODE_ENV !== 'test') {
  console.warn('VUE_APP_MAPTILER_KEY is not set; the basemap will not load.')
}

// Passed to new maplibregl.Map({ transformRequest }). Applies to every style,
// source, tile, glyph and sprite request, including after map.setStyle().
export function transformRequest (url) {
  // Self-hosted sprites are referenced as https://trailhub.org/map-styles/...
  // (MapLibre 1.x rejects relative sprite URLs); serve them from whichever
  // origin is running (localhost, preview channels, production).
  const SELF = 'https://trailhub.org/map-styles/'
  if (url && url.startsWith(SELF)) {
    return { url: origin() + '/map-styles/' + url.slice(SELF.length) }
  }
  if (url && url.startsWith('https://api.maptiler.com/') && MAPTILER_KEY) {
    const u = new URL(url)
    u.searchParams.set('key', MAPTILER_KEY)
    return { url: u.toString() }
  }
  return { url }
}
